"use client"

import * as React from "react"
import { StickyNote } from "lucide-react"

interface NotesAppProps {
  notesContent: string
  setNotesContent: (content: string) => void
  isWidget?: boolean
}

export function NotesApp({ notesContent, setNotesContent, isWidget = false }: NotesAppProps) {
  if (isWidget) {
    return (
      <div className="flex flex-col h-full bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-100 p-3 font-sans">
        <div className="flex items-center justify-between pb-2 border-b border-zinc-100 dark:border-zinc-800 shrink-0">
          <div className="flex items-center gap-1.5">
            <StickyNote className="size-3.5 text-amber-500" />
            <span className="text-xs font-bold text-zinc-800 dark:text-zinc-200">Bloco de Notas</span>
          </div>
          <span className="text-[10px] text-zinc-400 tabular-nums">{notesContent.length} chars</span>
        </div>
        <textarea
          value={notesContent}
          onChange={(e) => setNotesContent(e.target.value)}
          placeholder="Escreva suas anotações aqui..."
          className="flex-1 w-full mt-2 p-2.5 rounded-xl border border-zinc-200 dark:border-zinc-800 bg-amber-50/5 dark:bg-zinc-950 text-xs font-sans focus:outline-none focus:ring-2 focus:ring-[#004EB1] resize-none text-zinc-800 dark:text-zinc-200"
        />
      </div>
    )
  }

  return (
    <div className="flex-1 w-full overflow-hidden bg-zinc-50 dark:bg-zinc-950 p-6 flex flex-col items-center justify-center font-sans">
      <div className="max-w-xl w-full bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800 rounded-3xl p-6 shadow-xl space-y-4 flex flex-col h-[500px]">
        <div className="flex items-center gap-2">
          <StickyNote className="size-4 text-amber-500" />
          <h3 className="font-bold text-sm text-zinc-900 dark:text-white uppercase tracking-wider">Anotações Pessoais</h3>
        </div>
        <textarea
          value={notesContent}
          onChange={(e) => setNotesContent(e.target.value)}
          placeholder="Escreva suas anotações aqui..."
          className="flex-1 w-full p-4 rounded-2xl border border-zinc-250 dark:border-zinc-800 bg-amber-50/5 dark:bg-zinc-950 text-sm font-sans focus:outline-none focus:ring-2 focus:ring-[#004EB1] resize-none text-zinc-800 dark:text-zinc-200"
        />
        <div className="text-xs text-zinc-400 text-right">Auto-salvo • {notesContent.length} caracteres</div>
      </div>
    </div>
  )
}
